import { fetchTcfVendorList } from 'mini-mail-gdpr-ad-tcf';
import { orchestrator } from 'satcheljs';
import {
    retrieveGdprAdsV3VendorList,
    setVendorList,
} from '../../actions/gdprAdsV3/advertisingOptionsActions';

export default orchestrator(retrieveGdprAdsV3VendorList, async actionMessage => {
    const vendorList = await fetchTcfVendorList();

    // We need to de-reference the vendorList of the MobX functions used later with this orchestrator and use a copy in the store
    // The reason is MobX will convert vendorList's properties like vendors to Observable Arrays instead of the arrays
    // When this happens, passing vendorList back to the consent string sdk will not work as Array.isArray(observable([])) will yield false and consent string sdk will treat vendorList as an invalid vendorList
    // It also has the method to use MobX toJS() to convert vendorList back to array-like before passing back to the external library but this needs to be done in every caller
    const vendorListCopy = JSON.parse(JSON.stringify(vendorList));
    setVendorList(vendorListCopy);
});
